import {
  AtomicChecker,
  SectionChecker
} from "./chunk-EINJ42AI.mjs";
import {
  countWords,
  getDensity,
  wordExists
} from "./chunk-D3GX5FQV.mjs";

// src/checker/check-content.ts
var CheckContent = class extends SectionChecker {
  constructor(domContent, keyword, t) {
    var _a, _b;
    const contentText = ((_a = domContent.body) == null ? void 0 : _a.innerText) || ((_b = domContent.body) == null ? void 0 : _b.textContent) || "";
    super("Content score", contentText, keyword, t);
    this.domContent = domContent;
    this.checkContentMinimumWords();
    this.checkH1Exists();
    this.checkH1ContainsKeyword();
    this.checkFirstParagraphContainsKeyword();
    this.checkDensity();
    this.checkLinkExists();
    this.checkImageExists();
    this.checkImageAltContainsKeword();
    this.checkImageTitleContainsKeword();
  }
  checkContentMinimumWords() {
    const contentLength = countWords(this.text);
    const perfectMinimum = 300;
    const goodMinimum = 150;
    const message = new AtomicChecker(
      "CONTENT_MINIMUM_WORDS",
      this.t("CONTENT_MINIMUM_WORDS", "short", perfectMinimum)
    );
    if (contentLength > 0) {
      if (contentLength >= perfectMinimum) {
        message.score = 31;
        message.text = this.t("CONTENT_MINIMUM_WORDS", "perfect", contentLength);
        message.status = "perfect";
      } else if (contentLength >= goodMinimum) {
        message.score = 21;
        message.status = "good";
        message.text = this.t("CONTENT_MINIMUM_WORDS", "good", contentLength);
      } else {
        message.score = 1;
      }
    }
    this.score += message.score;
    this.messages.push(message.getResult());
  }
  checkH1Exists() {
    var _a;
    const listOfH1 = this.domContent.getElementsByTagName("h1");
    const message = new AtomicChecker(
      "H1_EXIST",
      this.t("H1_EXIST", "not_exists")
    );
    if (listOfH1.length > 0) {
      for (const h1 of listOfH1) {
        if (!!((_a = h1.textContent) == null ? void 0 : _a.trim())) {
          message.score = 5;
          message.text = this.t("H1_EXIST", "exists");
          message.status = "perfect";
          break;
        }
      }
    }
    this.score += message.score;
    this.messages.push(message.getResult());
  }
  checkH1ContainsKeyword() {
    const listOfH1 = this.domContent.getElementsByTagName("h1");
    const message = new AtomicChecker(
      "H1_USE_KEYWORD",
      this.t("H1_USE_KEYWORD", "not_used", this.keyword)
    );
    if (listOfH1.length > 0) {
      for (const h1 of listOfH1) {
        if (wordExists(h1.textContent || "", this.keyword)) {
          message.score = 14;
          message.text = this.t("H1_USE_KEYWORD", "used", this.keyword);
          message.status = "perfect";
          break;
        }
      }
    }
    this.score += message.score;
    this.messages.push(message.getResult());
  }
  checkFirstParagraphContainsKeyword() {
    const firstParagraph = this.domContent.querySelector("p");
    const message = new AtomicChecker(
      "FIRST_PARAGRAPH_CONTAINS_KEYWORD",
      this.t("FIRST_PARAGRAPH_CONTAINS_KEYWORD", "not_used", this.keyword)
    );
    if (firstParagraph && wordExists(firstParagraph.textContent || "", this.keyword)) {
      message.score = 5;
      message.text = this.t(
        "FIRST_PARAGRAPH_CONTAINS_KEYWORD",
        "used",
        this.keyword
      );
      message.status = "perfect";
    }
    this.score += message.score;
    this.messages.push(message.getResult());
  }
  checkDensity() {
    const message = new AtomicChecker(
      "DENSITY",
      this.t("DENSITY", "bad", this.keyword)
    );
    const [densityResult, keywordFound] = getDensity(this.text, this.keyword);
    if (densityResult > 0) {
      message.score = 20;
      message.text = this.t(
        "DENSITY",
        "perfect",
        densityResult,
        this.keyword,
        keywordFound
      );
      message.status = "perfect";
    }
    this.score += message.score;
    this.messages.push(message.getResult());
  }
  checkLinkExists() {
    const aTags = this.domContent.getElementsByTagName("a");
    const message = new AtomicChecker(
      "LINK_EXISTS",
      this.t("LINK_EXISTS", "not_exists")
    );
    if (aTags.length > 0) {
      message.text = this.t("LINK_EXISTS", "exists", aTags.length);
      message.status = "perfect";
      message.score = 10;
    }
    this.score += message.score;
    this.messages.push(message.getResult());
  }
  checkImageExists() {
    const imageTags = this.domContent.getElementsByTagName("img");
    const message = new AtomicChecker(
      "IMG_EXISTS",
      this.t("IMG_EXISTS", "not_exists")
    );
    if (imageTags.length > 0) {
      message.text = this.t("IMG_EXISTS", "exists");
      message.status = "perfect";
      message.score = 5;
    }
    this.score += message.score;
    this.messages.push(message.getResult());
  }
  checkImageAltContainsKeword() {
    const listOfImg = this.domContent.getElementsByTagName("img");
    const message = new AtomicChecker(
      "IMG_ALT_USE_KEYWORD",
      this.t("IMG_ALT_USE_KEYWORD", "not_used", this.keyword)
    );
    if (listOfImg.length > 0) {
      for (const img of listOfImg) {
        if (img.alt && wordExists(img.alt, this.keyword)) {
          message.score = 5;
          message.text = this.t("IMG_ALT_USE_KEYWORD", "used", this.keyword);
          message.status = "perfect";
          break;
        }
      }
    }
    this.score += message.score;
    this.messages.push(message.getResult());
  }
  checkImageTitleContainsKeword() {
    const listOfImg = this.domContent.getElementsByTagName("img");
    const message = new AtomicChecker(
      "IMG_TITLE_USE_KEYWORD",
      this.t("IMG_TITLE_USE_KEYWORD", "not_used", this.keyword)
    );
    if (listOfImg.length > 0) {
      for (const img of listOfImg) {
        if (img.title && wordExists(img.title, this.keyword)) {
          message.score = 5;
          message.text = this.t("IMG_TITLE_USE_KEYWORD", "used", this.keyword);
          message.status = "perfect";
          break;
        }
      }
    }
    this.score += message.score;
    this.messages.push(message.getResult());
  }
};

export {
  CheckContent
};
